module.exports = __webpack_public_path__ + "static/HomeScreen-98047f7a7464dcbe9c7e0856ba35f114.mp4";